/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/card_holder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveCardHolderRequest": {
                "fields": {
                  "cardHolderToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveCardHolderResponse": {
                "fields": {
                  "cardHolder": {
                    "type": ".squareup.corporate_card.resources.CardHolder",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCardHolderRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCardHolderResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveCardHolderRequest @ squareup/corporate_card/service/retrieve_card_holder.proto at 11:1
 */
export const RetrieveCardHolderRequest = $root.lookupType('squareup.corporate_card.service.RetrieveCardHolderRequest');
fixType(RetrieveCardHolderRequest, {
  cardHolderToken: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveCardHolderRequest);
/**
 * SOURCE RetrieveCardHolderResponse @ squareup/corporate_card/service/retrieve_card_holder.proto at 18:1
 */
export const RetrieveCardHolderResponse = $root.lookupType('squareup.corporate_card.service.RetrieveCardHolderResponse');
fixType(RetrieveCardHolderResponse);
Builder.createAndAttachToType(RetrieveCardHolderResponse);